import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import DataEntryHeader from "./dataEntry/DataEntryHeader";
import DataEntryContent from "./dataEntry/DataEntryContent";
import DataEntryPrefillBanner from "./dataEntry/DataEntryPrefillBanner";
import DataEntryPrefillModal from "./dataEntry/DataEntryPrefillModal";
import { useESGDataEntryStore } from "@/features/esg/hooks/useESGReportStore";

const DataEntryStep = observer(() => {
  const { loadPrefillSuggestions } = useESGDataEntryStore();

  useEffect(() => {
    loadPrefillSuggestions();
  }, []);

  return (
    <div className="gap-y-3 flex flex-col flex-1 min-h-0 overflow-hidden">
      <DataEntryHeader />

      <DataEntryPrefillBanner />

      <DataEntryContent />

      <DataEntryPrefillModal />
    </div>
  );
});

export default DataEntryStep;
